import React, { useState, useEffect } from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { addMonths, format } from "date-fns";

const OPTIONS = [
  { label: "6 MONTHS", value: "6" },
  { label: "12 MONTHS", value: "12" },
  { label: "OTHER", value: "custom" }
];

const ExpectedEndDateSelector = ({ initialDate, formEndDate, onSelect }) => {
  const [selected, setSelected] = useState(null);

  const computeEndDate = (value) => {
    if (value === "6") return addMonths(initialDate, 6);
    if (value === "12") return addMonths(initialDate, 12);
    return null;
  };

  // 🔥 Auto-select based on existing form value
  useEffect(() => {
    if (!initialDate || !formEndDate) return;
  
    const end6 = addMonths(initialDate, 6);
    const end12 = addMonths(initialDate, 12);
  
    const formVal = format(formEndDate, "yyyy-MM-dd");
  
    if (format(end6, "yyyy-MM-dd") === formVal) {
      setSelected("6");
      onSelect && onSelect({ option: "6", date: end6 });
      return;
    }
  
    if (format(end12, "yyyy-MM-dd") === formVal) {
      setSelected("12");
      onSelect && onSelect({ option: "12", date: end12 });
      return;
    }
  
    // HERE IS THE FIX FOR OTHER
    setSelected("custom");
    onSelect && onSelect({ option: "custom", date: formEndDate });
  }, [initialDate, formEndDate]);
  

  const handlePress = (item) => {
    setSelected(item.value);

    const endDate = computeEndDate(item.value);

    onSelect &&
      onSelect({
        option: item.value,
        date: endDate
      });
  };

  return (
    <View style={styles.container}>
      {OPTIONS.map((item) => {
        const isSelected = selected === item.value;
        const end = computeEndDate(item.value);

        return (
          <TouchableOpacity
            key={item.value}
            onPress={() => handlePress(item)}
            style={[styles.card, isSelected && styles.cardSelected]}
          >
            <MaterialCommunityIcons
              name="calendar-month"
              size={34}
              color="#676767"
              style={{ marginBottom: 10 }}
            />

            <Text style={styles.label}>{item.label}</Text>

            <Text style={styles.subLabel}>
              {item.value === "custom"
                ? "other"
                : format(end, "dd/MM/yyyy")}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

export default ExpectedEndDateSelector;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10
  },
  card: {
    width: "31%",
    backgroundColor: "#f9f9f9",
    paddingVertical: 25,
    borderRadius: 14,
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#e0e0e0"
  },
  cardSelected: {
    borderWidth: 2,
    borderColor: "#8b4dff",
    backgroundColor: "#f5efff"
  },
  label: {
    fontSize: 15,
    fontWeight: "600",
    marginBottom: 5,
    color: "#333"
  },
  subLabel: {
    fontSize: 14,
    color: "#555"
  }
});
